import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateDocumentPayload,
  DocumentVaultDto,
  UpdateDocumentPayload,
} from '@/types/documentVault';
import type { ListFilterPayload } from '@/types/filters';

// ============================================
// Employee-service Document Vault
// Backend: backend/employee-service/docs/api-endpoints.md:297-536
// Responses are the uniform envelope; the axios interceptor unwraps `data`,
// so `response.data` is already the payload.
// ============================================

interface ListParams {
  page?: number;
  size?: number;
  sort?: string;
}

const BASE = '/employee-service/v1/documents';

export const createDocument = async (
  payload: CreateDocumentPayload,
): Promise<DocumentVaultDto> => {
  const response = await api.post<DocumentVaultDto>(BASE, payload, {
    successToast: true,
  });
  return response.data;
};

export const getDocumentById = async (id: string): Promise<DocumentVaultDto> => {
  const response = await api.get<DocumentVaultDto>(`${BASE}/${id}`);
  return response.data;
};

export const listDocuments = async (
  params: ListParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<DocumentVaultDto>> => {
  const response = await api.post<PaginatedResponse<DocumentVaultDto>>(
    `${BASE}/list`,
    body ?? {},
    { params },
  );
  return response.data;
};

export const updateDocument = async (
  id: string,
  payload: UpdateDocumentPayload,
): Promise<DocumentVaultDto> => {
  const response = await api.put<DocumentVaultDto>(`${BASE}/${id}`, payload, {
    successToast: true,
  });
  return response.data;
};

/** Soft delete — sets status=INACTIVE. Idempotent on the backend. */
export const deleteDocument = async (id: string): Promise<void> => {
  await api.delete(`${BASE}/${id}`, { successToast: true });
};
